<div class="default-language-picker-langs">
  <span
    *ngFor="let lang of langs"
    class="lang-icon"
    (click)="handleLangClick(lang.name)"
  >
    <img [src]="'assets/lang-icons/' + lang.icon" [alt]="lang.name" />
  </span>
</div>
